<template>
  <v-container id="HomePage" fluid tag="section">
    <v-row>
      <v-snackbar v-model="snackbar" top right dense :timeout="snackBarTimeout" :color="snackbarColor">
        {{ snackbarText }}
        <v-btn color="primary" text @click="snackbar = false">
          Close
        </v-btn>
      </v-snackbar>
    </v-row>
    <v-app-bar color="#b88611" dense dark>
      <v-toolbar-title>Your Past </v-toolbar-title>

      <v-spacer />
    </v-app-bar>
    <div>
      <v-row>
        <v-col cols="12" md="12">
          <base-material-card color="#455A64" class="px-5 py-3" title="Here they are !!">
            <v-card-text class="px-0 pb-0">
              <v-sheet />

              <v-row>
                <v-col lg="12" sm="12" cols="12">
                  <v-card-title>
                    <v-spacer />
                    <v-text-field v-model="searchO" append-icon="mdi-magnify" label="Search" single-line hide-details
                      clearable dense outlined />
                  </v-card-title>
                  <v-data-table :headers="headers" :items="items" :search="searchO">
                    <template v-slot:item.view="{ item }">
                      <v-btn color="green" @click="seeMore(item.id)">
                        View More
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-card-text>
          </base-material-card>
        </v-col>
      </v-row>
      <!-- -----------------------Loader---------------------- -->
      <v-row>
        <v-dialog v-model="loader" persistent width="200">
          <v-card>
            <v-card-text>
              <v-container>
                <v-row class="justify-center">
                  Please Wait...
                </v-row>
                <v-row class="mt-2 justify-center">
                  <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import Vue from 'vue';
import VueCookies from 'vue-cookies';
import db from './api/firebaseInit';
import * as $ from 'jquery';
// eslint-disable-next-line no-unused-vars
import DataTable from 'datatables.net';
import Jspdf from 'jspdf';
import 'jspdf-autotable';

Vue.use(VueCookies);

export default {
  data: function () {
    return {
      dataReady: false,
      loader: true,
      items: [],
      searchO: '',
      headers: [
        { text: 'Date', value: 'date' },
        { text: 'Reason', value: 'why' },
        { text: 'Venue', value: 'where' },
        { text: 'By', value: 'by' },
        { text: 'View more', value: 'view', align: 'center' },
      ],
      // SnackBar
      snackbar: false,
      snackbarColor: '',
      snackbarText: '',
      snackBarTimeout: 3000,
    };
  },
  mounted() {
    if (!VueCookies.get('maman')) {
      this.snackbarText = 'Not Authorized';
      this.snackbarColor = 'error';
      this.snackBarTimeout = 3000;
      this.snackbar = true;
      this.$router.push('/');
      return;
    }
    db.collection('orderIDsBackup')
      .get()
      .then((snapshot) => {
        snapshot.forEach((doc) => {
          // // console.log(doc.data());
          var tempObj = {
            why: doc.data().why,
            where: doc.data().where,
            by: doc.data().by,
            date: doc.data().date,
            // time: doc.data().time,
            id: doc.id,
          };
          this.items.push(tempObj);
        });
        this.loader = false;
      })
      .catch((err) => {
        const error = err;
        this.loader = false;

        // console.log('Error getting documents', error)
      });
  },
  methods: {
    seeMore: function (id) {
      // console.log(id)
      VueCookies.set('seeMoreBackup', id);
      this.$router.push('/backupView');
    },
    generatePDF: function (e) {
      const doc = new Jspdf();
      doc.text('My Stock', 80, 10);
      doc.autoTable({ html: '#table_id' });
      doc.save('stock.pdf');
    },
  },
};
</script>
